import type { JSX } from 'solid-js';
import { t } from '../../i18n';
import { KIND_LABEL_KEY } from '../../lib/notification-labels';
import type {
  NotificationCellWrite,
  NotificationSettingsRow,
} from '../../lib/notification-settings';
import { flipCells, mediumState } from '../../lib/notification-tiers';
import { NotificationMediumControl } from './NotificationMediumControl';

// One topic under a tier's Fine-tune: its plain label, then its own Email and
// Browser control. The same pure functions as the tier, over a list of one.

export function NotificationTopicRow(props: {
  readonly row: NotificationSettingsRow;
  readonly onWrite: (cells: readonly NotificationCellWrite[]) => void;
}): JSX.Element {
  const name = (): string => t(KIND_LABEL_KEY[props.row.kind]);
  const flip =
    (medium: 'email' | 'push') =>
    (next: boolean): void =>
      props.onWrite(flipCells([props.row], medium, next));

  return (
    <li class="notification-topic">
      <span class="notification-topic__name">{name()}</span>
      <div class="notification-topic__media">
        <NotificationMediumControl
          medium="email"
          state={mediumState([props.row], 'email')}
          name={name()}
          onChange={flip('email')}
        />
        <NotificationMediumControl
          medium="push"
          state={mediumState([props.row], 'push')}
          name={name()}
          onChange={flip('push')}
        />
      </div>
    </li>
  );
}
